import type {Theme} from "@mui/material";
import {styled} from "@mui/material/styles";
import {Swiper} from "swiper/react";

export const WhiteNavSwiper = styled(Swiper)(()  => ({
  '--swiper-navigation-color': '#000',
  '--swiper-pagination-color': '#000',
}))

const MainSwiperStyles = ({theme}: { theme: Theme}) => ({
  height: '100%',
  '& .swiper-slide': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .swiper-button-prev, .swiper-button-next': {
    height: '3rem',
    width: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: '50%',
  },
  '& .swiper-pagination-bullet': {
    backgroundColor: 'white',
  },
  '& .swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction': {
    bottom: '4em',
    position: 'fixed',
    [theme.breakpoints.up('sm')]: {
      bottom: '2em',
    },
  },
  '& .swiper-button-next:after, .swiper-button-prev:after': {
    fontSize: '1.4em !important',
    zIndex: 999,
  },
  '& .swiper-slide img': {
    display: 'block',
    width: '100%',
    height: '38em',
    objectFit: 'contain',
    borderRadius: '1em',
  },
  '& .swiper-slide-thumb-active': {
    opacity: 1
  },
  [theme.breakpoints.up('xs')]: {
    '& .swiper-button-prev, .swiper-button-next': {
      display: 'flex'
    }
  }
})

export const MainSwiper = styled(WhiteNavSwiper)(MainSwiperStyles);
